import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import ThemeVariables from "./Components/ThemeVariables";
// import Jashanenoor from './Components/Munasibat/Jashanenoor';
// import Muharram from './Components/Munasibat/Muharram';
// import AyyameFatamiya from './Components/Munasibat/AyyameFatamiya';
import Taaruf from "./Components/Taaruf/taaruf";
import NoorDiary from "./Components/Tableeghat/noorDiary2025";
import Tazakurat from "./Components/Tazakurat/tazakurat";
import Mujallah from "./Components/Tableeghat/Mujallah";
import Mutabaat from "./Components/Tableeghat/Mutabaat";
import BookDetail from "./Components/Tableeghat/BookDetail";
import ArticleTableeghat from "./Components/Tazakurat/Article";
import Classadmissionform from "./Components/ClassForm/Classadmissionform";
import OurBooks from "./Components/Tableeghat/OurBooks";
import Home from "./Components/Home/home";
import KeyPage from "./Components/Database/KeyPage";
import FormPage from "./Components/Database/FormPage";
import ThankYou from "./Components/Database/ThankYou";
import MunasibaatDetail from "./Components/Munasibat/MunasibaatDetail";
import Exhibition from "./Components/Exhibition/Exhibition";
// import Exhibition from './Components/Munasibat/Exibitions';

function App() {
  useEffect(() => {
    document.title = "Mushtaqan e Noor";
  }, []);
  return (
    <ThemeProvider>
      <ThemeVariables />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/taaruf" element={<Taaruf />} />
          {/* <Route path="/munasibat/jashnenoor" element={<Jashanenoor />} />
          <Route path="/munasibat/muharram" element={<Muharram />} />
          <Route path="/munasibat/ayyamefatamiya" element={<AyyameFatamiya />} /> */}
          <Route path="/munasibat/exhibition" element={<Exhibition />} />

          {/* Munasibaat Detail Page */}
          <Route path="/munasibat/detail/:id" element={<MunasibaatDetail />} />
          {/* Tazakrat Page */}
          <Route path="/tazakurat" element={<Tazakurat />} />
          {/* Tableghaat pages */}
          <Route path="/tableeghat/noordiary" element={<NoorDiary />} />
          <Route path="/tableeghat/mujallah" element={<Mujallah />} />
          <Route path="/tableeghat/mutabaat" element={<Mutabaat />} />
          <Route path="/tableeghat/mutabaat/:id" element={<BookDetail />} />
          <Route path="/tableeghat/:id" element={<ArticleTableeghat />} />
          <Route path="/tableeghat/bookDetail" element={<BookDetail />} />
          <Route path="/tableeghat/ourBooks" element={<OurBooks />} />
          <Route path="/کلاس-داخلہ-فارم" element={<Classadmissionform />} />
          {/* Database pages */}
          <Route path="/database-enterKey" element={<KeyPage />} />
          <Route path="/database-form" element={<FormPage />} />
          <Route path="/database-thankyou" element={<ThankYou />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
